module.exports = {
    ...require('./isStoreNameFilter'),
    ...require('./asyncEvery'),
    ...require('./asyncSome'),
    ...require('./checkValueExistence'),
    ...require('./arrayToArrayMatcher'),
}